var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":_vm.noTransition?'':'fade'}},[(_vm.show)?_c('div',{staticClass:"loading-wrap"},[_c('label',{staticClass:"loading-btn loading",style:({color: _vm.color})}),_vm._t("default")],2):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }